import { FC } from 'react';
import { dibsLazyClient } from 'dibs-lazy/src/dibsLazyClient';

// components
import { ClientSuspense } from 'dibs-elements/src/ClientSuspense';
import { PdpSharedDetail, PdpSharedDetailProps } from './PdpSharedDetail';

const LabReportTip = dibsLazyClient(
    () =>
        import(
            /* webpackChunkName: "PdpSharedDetailLabReportTip" */ './PdpSharedDetailLabReportTipLazy'
        )
);
export const PdpSharedDetailLabReport: FC<PdpSharedDetailProps> = ({ ...props }) => {
    return (
        <>
            <PdpSharedDetail {...props} />
            <ClientSuspense fallback="">
                <LabReportTip />
            </ClientSuspense>
        </>
    );
};
